/**
 * ff-product.js — FourFlow Shopify OS2.0
 */
(function () {
  'use strict';

  var PRODUCT = window.FF_PRODUCT || { id: 0, variants: [], media: [] };
  var COLORS  = window.FF_COLORS  || [];

  var state = {
    variantId:    null,
    qty:          1,
    mediaIndex:   0,
    bottleColors: []
  };

  function qs(sel, ctx)  { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function money(cents) {
    var n = (cents / 100).toFixed(2);
    return '$' + (n.endsWith('.00') ? n.slice(0, -3) : n);
  }

  function moneyHtml(cents) {
    return '<span class="money">' + money(cents) + '</span>';
  }

  /* ── Currency symbol fix ────────────────────────────────────────── */
  function getCurrencyCode() {
    var m = document.cookie.match(/cart_currency=([A-Z]{3})/);
    return m ? m[1] : 'USD';
  }

  var CURRENCY_SYMBOLS = {
    USD:'$',  EUR:'€',  GBP:'£',  JPY:'¥',  CAD:'CA$', AUD:'A$',
    CHF:'Fr', CNY:'¥',  KRW:'₩',  MXN:'MX$', BRL:'R$',  INR:'₹',
    SGD:'S$', HKD:'HK$', NOK:'kr', SEK:'kr', DKK:'kr', NZD:'NZ$',
    ZAR:'R',  THB:'฿',  MYR:'RM', IDR:'Rp', PHP:'₱',  VND:'₫',
    TWD:'NT$',CZK:'Kč', PLN:'zł', HUF:'Ft', ILS:'₪',  TRY:'₺'
  };

  function fixSymbolEl(el) {
    var currency = getCurrencyCode();
    if (currency === 'USD') return;
    var sym = CURRENCY_SYMBOLS[currency];
    if (!sym || sym === '$') return;
    var moneyEl = (el.querySelector && el.querySelector('.money')) || el;
    var text    = moneyEl.textContent || '';
    if (text.charAt(0) === '$') {
      moneyEl.textContent = sym + text.slice(1);
    }
  }

  /* Fix symbols on cart drawer: item prices + subtotal */
  function fixCartSymbols() {
    var stEl = qs('[data-ff-cart-subtotal]');
    var liEl = qs('[data-ff-cart-lines]');
    if (stEl) fixSymbolEl(stEl);
    if (liEl) Array.prototype.forEach.call(liEl.querySelectorAll('.money'), fixSymbolEl);
  }

  /* Copy main price text to sticky bar after Bucks converts it */
  function syncSticky() {
    var priceEl     = qs('[data-ff-price]');
    var stickyPrice = qs('[data-ff-sticky-price]');
    if (!priceEl || !stickyPrice) return;
    fixSymbolEl(priceEl);
    var mainTxt   = priceEl.textContent.trim();
    var stickyTxt = stickyPrice.textContent.trim();
    if (mainTxt && mainTxt !== stickyTxt) {
      stickyPrice.textContent = mainTxt;
    }
  }
  /* ──────────────────────────────────────────────────────── */

  function findVariant(id) {
    return PRODUCT.variants.find(function (v) { return v.id === id; }) || null;
  }

  function applyVariant(id) {
    if (!id) return;
    state.variantId = id;
    var v = findVariant(id);
    if (!v) return;
    qsa('[data-ff-variant-input]').forEach(function (el) { el.value = id; });
    var priceEl   = qs('[data-ff-price]');
    var compareEl = qs('[data-ff-compare-price]');
    if (priceEl) priceEl.innerHTML = moneyHtml(v.price);
    if (compareEl) {
      var hasCompare = v.compare_at_price && v.compare_at_price > v.price;
      compareEl.innerHTML = hasCompare ? moneyHtml(v.compare_at_price) : '';
      compareEl.style.display = hasCompare ? '' : 'none';
    }
    var atcBtn = qs('[data-ff-add-to-cart]');
    if (atcBtn) {
      atcBtn.disabled = !v.available;
      atcBtn.textContent = v.available ? (atcBtn.dataset.ffLabel || 'Add to cart') : 'Sold Out';
    }
    var stickyPrice = qs('[data-ff-sticky-price]');
    if (stickyPrice) stickyPrice.innerHTML = moneyHtml(v.price);
    [200, 800].forEach(function (ms) {
      setTimeout(function () {
        if (priceEl)     fixSymbolEl(priceEl);
        if (stickyPrice) fixSymbolEl(stickyPrice);
        syncSticky();
      }, ms);
    });
  }

  function buildColorPicker(container, bottleCount) {
    container.innerHTML = '';
    if (!COLORS.length) return;
    while (state.bottleColors.length < bottleCount) {
      state.bottleColors.push(COLORS[0] ? COLORS[0].label : '');
    }
    state.bottleColors = state.bottleColors.slice(0, bottleCount);
    var wrapper = document.createElement('div');
    wrapper.style.cssText = 'padding:12px 0 4px;border-top:1px solid var(--ff-border);margin-top:10px;display:flex;flex-direction:column;gap:10px;';
    for (var b = 0; b < bottleCount; b++) {
      (function (bi) {
        var row = document.createElement('div');
        row.style.cssText = 'display:flex;align-items:center;gap:10px;';
        var lbl = document.createElement('span');
        lbl.style.cssText = 'font-size:11px;font-weight:700;color:var(--ff-text-muted);font-family:var(--ff-font-mono);letter-spacing:.04em;min-width:68px;flex-shrink:0;';
        lbl.textContent = bottleCount > 1 ? 'BOTTLE ' + (bi + 1) : 'COLOR';
        row.appendChild(lbl);
        var selName = document.createElement('span');
        selName.style.cssText = 'font-size:12.5px;font-weight:600;color:var(--ff-dark);';
        selName.textContent = state.bottleColors[bi] || (COLORS[0] ? COLORS[0].label : '');
        COLORS.forEach(function (c) {
          var sw = document.createElement('button');
          sw.type = 'button';
          sw.className = 'ff-color-swatch' + (state.bottleColors[bi] === c.label ? ' is-selected' : '');
          sw.style.background = c.color;
          sw.title = c.label;
          sw.setAttribute('aria-label', c.label);
          sw.addEventListener('click', function (e) {
            e.stopPropagation();
            row.querySelectorAll('.ff-color-swatch').forEach(function (s) { s.classList.remove('is-selected'); });
            sw.classList.add('is-selected');
            state.bottleColors[bi] = c.label;
            selName.textContent = c.label;
          });
          row.appendChild(sw);
        });
        row.appendChild(selName);
        wrapper.appendChild(row);
      })(b);
    }
    container.appendChild(wrapper);
    container.style.display = '';
  }

  function initBundles() {
    var cards = qsa('[data-ff-bundle-card]');
    if (!cards.length) return;
    cards.forEach(function (card) {
      function selectCard() {
        var vid = parseInt(card.dataset.ffVariantId, 10);
        if (!vid) return;
        cards.forEach(function (c) {
          c.classList.remove('is-selected');
          c.setAttribute('aria-checked', 'false');
          var cp = c.querySelector('[data-ff-bundle-colors]');
          if (cp) { cp.style.display = 'none'; }
        });
        card.classList.add('is-selected');
        card.setAttribute('aria-checked', 'true');
        applyVariant(vid);
        var bottleCount = parseInt(card.dataset.ffBottleCount, 10) || 1;
        var colorEl = card.querySelector('[data-ff-bundle-colors]');
        if (colorEl && COLORS.length) buildColorPicker(colorEl, bottleCount);
      }
      card.addEventListener('click', selectCard);
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectCard(); }
      });
    });
    var first = cards.find(function (c) {
      var vid = parseInt(c.dataset.ffVariantId, 10);
      var v = findVariant(vid);
      return v && v.available;
    }) || cards[0];
    if (first) first.click();
  }

  function buildMediaNode(media) {
    var el;
    if (media.type === 'image') {
      el = document.createElement('img');
      el.src = media.src; el.srcset = media.srcset || ''; el.alt = media.alt; el.loading = 'eager';
      el.style.cssText = 'width:100%;height:100%;object-fit:contain;display:block;';
    } else if (media.type === 'video') {
      el = document.createElement('video');
      el.src = media.src; el.controls = true; el.playsInline = true; el.preload = 'metadata';
      el.style.cssText = 'width:100%;height:100%;object-fit:contain;display:block;';
      if (media.poster) el.poster = media.poster;
    } else if (media.type === 'external_video') {
      el = document.createElement('iframe');
      el.src = media.src; el.frameBorder = '0'; el.allow = 'autoplay; encrypted-media; picture-in-picture'; el.allowFullscreen = true;
      el.style.cssText = 'width:100%;height:100%;border:none;display:block;';
    } else {
      el = document.createElement('img');
      el.src = media.poster || media.src; el.alt = media.alt;
      el.style.cssText = 'width:100%;height:100%;object-fit:contain;display:block;';
    }
    return el;
  }

  function showMedia(index) {
    var media = PRODUCT.media[index];
    if (!media) return;
    state.mediaIndex = index;
    var main = qs('[data-ff-gallery-main]');
    if (main) {
      var existing = main.querySelector('video');
      if (existing) existing.pause();
      main.innerHTML = '';
      main.appendChild(buildMediaNode(media));
    }
    qsa('[data-ff-thumb]').forEach(function (t, i) {
      t.classList.toggle('is-active', i === index);
      t.setAttribute('aria-pressed', i === index ? 'true' : 'false');
    });
  }

  function initGallery() {
    if (!PRODUCT.media.length) return;
    qsa('[data-ff-thumb]').forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { showMedia(i); });
    });
    var main = qs('[data-ff-gallery-main]');
    if (main) {
      var tx = 0;
      main.addEventListener('touchstart', function (e) { tx = e.changedTouches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - tx;
        if (Math.abs(dx) < 40) return;
        if (dx < 0 && state.mediaIndex < PRODUCT.media.length - 1) showMedia(state.mediaIndex + 1);
        else if (dx > 0 && state.mediaIndex > 0) showMedia(state.mediaIndex - 1);
      }, { passive: true });
    }
    showMedia(0);
  }

  function initQty() {
    var valEl = qs('[data-ff-qty-val]');
    function render() { if (valEl) valEl.textContent = state.qty; }
    var inc = qs('[data-ff-inc]');
    var dec = qs('[data-ff-dec]');
    if (inc) inc.addEventListener('click', function () { state.qty = Math.min(state.qty + 1, 99); render(); });
    if (dec) dec.addEventListener('click', function () { state.qty = Math.max(state.qty - 1, 1); render(); });
  }

  function updateCartCount(count) {
    qsa('[data-ff-cart-count]').forEach(function (el) { el.textContent = count; });
  }

  function cartAdd(variantId, qty, onSuccess) {
    var body = { id: variantId, quantity: qty };
    if (state.bottleColors && state.bottleColors.length > 0) {
      var props = {};
      if (state.bottleColors.length === 1) {
        if (state.bottleColors[0]) props['Color'] = state.bottleColors[0];
      } else {
        state.bottleColors.forEach(function (color, i) {
          if (color) props['Bottle #' + (i + 1)] = color;
        });
      }
      if (Object.keys(props).length) body.properties = props;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status) { showToast(data.description || 'Could not add item.'); return; }
      refreshCart();
      openDrawer();
      if (onSuccess) onSuccess();
    })
    .catch(function () { showToast('Something went wrong. Please try again.'); });
  }

  function refreshCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart);
  }

  function cartChange(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function renderCart(cart) {
    var linesEl     = qs('[data-ff-cart-lines]');
    var emptyEl     = qs('[data-ff-cart-empty]');
    var subtotalEl  = qs('[data-ff-cart-subtotal]');
    var checkoutBtn = qs('[data-ff-checkout]');
    updateCartCount(cart.item_count || 0);
    var isEmpty = !cart.items || !cart.items.length;
    if (emptyEl)     emptyEl.style.display = isEmpty ? 'flex' : 'none';
    if (checkoutBtn) checkoutBtn.disabled = isEmpty;
    if (subtotalEl)  subtotalEl.innerHTML = moneyHtml(cart.total_price);
    if (!linesEl) return;
    if (isEmpty) {
      linesEl.innerHTML = '';
    } else {
      linesEl.innerHTML = cart.items.map(function (item) {
        var imgSrc = item.featured_image ? item.featured_image.url : '';
        var propsHtml = '';
        if (item.properties) {
          Object.keys(item.properties).forEach(function (key) {
            if (item.properties[key]) propsHtml += '<div style="font-size:12px;color:var(--ff-text-muted);margin-top:2px;">' + key + ': ' + item.properties[key] + '</div>';
          });
        }
        return (
          '<div class="ff-cart-line" style="display:flex;gap:12px;align-items:flex-start;padding:14px 0;border-bottom:1px solid var(--ff-border);">' +
            (imgSrc ? '<img src="' + imgSrc + '" width="64" height="64" alt="' + item.product_title + '" loading="lazy" style="border-radius:10px;object-fit:cover;flex-shrink:0;">' : '') +
            '<div style="flex:1;min-width:0;">' +
              '<div style="font-weight:600;font-size:14px;">' + item.product_title + '</div>' +
              (item.variant_title && item.variant_title !== 'Default Title' ? '<div style="font-size:12px;color:var(--ff-text-muted);margin-top:2px;">' + item.variant_title + '</div>' : '') +
              propsHtml +
              '<div style="display:flex;align-items:center;gap:10px;margin-top:8px;">' +
                '<div class="ff-qty" style="border:1px solid var(--ff-border);">' +
                  '<button class="ff-qty__btn" data-ff-cart-btn data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease">−</button>' +
                  '<span class="ff-qty__val">' + item.quantity + '</span>' +
                  '<button class="ff-qty__btn" data-ff-cart-btn data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase">+</button>' +
                '</div>' +
                '<button data-ff-cart-btn data-key="' + item.key + '" data-qty="0" style="background:none;border:none;cursor:pointer;font-size:11.5px;color:var(--ff-text-muted);text-decoration:underline;padding:0;">Remove</button>' +
              '</div>' +
            '</div>' +
            '<div style="font-weight:700;font-size:15px;white-space:nowrap;padding-top:2px;"><span class="money">' + money(item.final_line_price) + '</span></div>' +
          '</div>'
        );
      }).join('');
      linesEl.onclick = function (e) {
        var btn = e.target.closest('[data-ff-cart-btn]');
        if (!btn) return;
        e.preventDefault();
        cartChange(btn.dataset.key, parseInt(btn.dataset.qty, 10));
      };
    }
    updateShipBar(cart.total_price);
    /* Fix currency symbols in cart after Bucks converts the numbers */
    [200, 800].forEach(function (ms) { setTimeout(fixCartSymbols, ms); });
  }

  function updateShipBar(totalCents) {
    var bar   = qs('[data-ff-ship-bar]');
    var msgEl = qs('[data-ff-ship-msg]');
    var thEl  = qs('[data-ff-ship-threshold]');
    if (!bar || !thEl) return;
    var threshold = parseInt(thEl.dataset.ffShipThreshold, 10);
    if (isNaN(threshold) || threshold <= 0) return;
    var pct = Math.min((totalCents / threshold) * 100, 100);
    bar.style.width = pct + '%';
    if (msgEl) {
      msgEl.innerHTML = totalCents >= threshold
        ? 'You\'ve unlocked free shipping!'
        : 'Add <span class="money">' + money(threshold - totalCents) + '</span> more for free shipping';
    }
  }

  function openDrawer() {
    var drawer  = qs('[data-ff-drawer]');
    var overlay = qs('[data-ff-overlay]');
    if (drawer)  drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }

  function closeDrawer() {
    var drawer  = qs('[data-ff-drawer]');
    var overlay = qs('[data-ff-overlay]');
    if (drawer)  drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  var _toastTimer = null;
  function showToast(msg) {
    var toast = qs('[data-ff-toast]');
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(_toastTimer);
    _toastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 2600);
  }

  function initStickyBar() {
    var bar = qs('[data-ff-sticky-bar]');
    if (!bar) return;
    var trigger = parseInt(bar.dataset.ffStickyTrigger, 10) || 300;
    var ticking = false;
    var visible = false;
    function update() {
      var shouldShow = window.scrollY > trigger;
      if (shouldShow !== visible) { visible = shouldShow; bar.classList.toggle('is-visible', shouldShow); }
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  }

  function initFaq() {
    qsa('[data-ff-faq-item]').forEach(function (item) {
      var btn = item.querySelector('[data-ff-faq-btn], [data-ff-faq-trigger]');
      if (!btn || btn._ffFaqBound) return;
      btn._ffFaqBound = true;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        qsa('[data-ff-faq-item]').forEach(function (i) { i.classList.remove('is-open'); });
        if (!isOpen) item.classList.add('is-open');
      });
    });
  }

  function initAtc() {
    var atcBtn    = qs('[data-ff-add-to-cart]');
    var buyBtn    = qs('[data-ff-buy-now]');
    var stickyAtc = qs('[data-ff-sticky-atc]');
    function doAdd(btn) {
      if (!state.variantId) { showToast('Please select an option.'); return; }
      if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
      cartAdd(state.variantId, state.qty, function () {
        if (btn) { btn.disabled = false; applyVariant(state.variantId); }
        showToast('Added to bag!');
      });
    }
    if (atcBtn)    atcBtn.addEventListener('click',    function () { doAdd(atcBtn); });
    if (stickyAtc) stickyAtc.addEventListener('click', function () { doAdd(stickyAtc); });
    if (buyBtn)    buyBtn.addEventListener('click', function () {
      if (!state.variantId) return;
      fetch('/cart/clear.js', { method: 'POST' })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: state.variantId, quantity: state.qty })
          });
        })
        .then(function () { window.location.href = '/checkout'; });
    });
  }

  function initDrawerTriggers() {
    qsa('[data-ff-close-drawer]').forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });
    var overlay  = qs('[data-ff-overlay]');
    var checkout = qs('[data-ff-checkout]');
    if (overlay)  overlay.addEventListener('click', closeDrawer);
    if (checkout) checkout.addEventListener('click', function () { window.location.href = '/checkout'; });
    qsa('[data-ff-open-cart], [data-ff-cart-trigger]').forEach(function (el) {
      el.addEventListener('click', openDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  function initCurrencySync() {
    /* Poll every 500ms — fix symbols on sticky bar AND cart drawer */
    setInterval(function () {
      syncSticky();
      fixCartSymbols();
    }, 500);
    ['currency:change','currencyChanged','bucks:change','bucks:convert'].forEach(function (evtName) {
      document.addEventListener(evtName, function () {
        setTimeout(function () { syncSticky(); fixCartSymbols(); }, 100);
      });
    });
  }

  function boot() {
    initBundles();
    initGallery();
    initQty();
    initAtc();
    initDrawerTriggers();
    initStickyBar();
    initFaq();
    initCurrencySync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
